<template>
  <div class="tw:flex">
    <div class="tw:flex-1">
      <BaseButton
        circle
        color="ai"
        data-testid="copy-button"
        icon="copy-content"
        new-design
        new-icon
        @click="handleCopyClick"
      >
        <StreemTooltip
          anchor="top middle"
          self="bottom middle"
        >
          {{ getLocaleText("global.copy") }}
        </StreemTooltip>
      </BaseButton>
    </div>

    <div class="tw:flex tw:flex-1 tw:justify-center">
      <Transition name="fade">
        <div
          v-if="copied"
          class="tw:rounded-md tw:bg-blue-700 tw:px-4 tw:py-2 tw:text-white"
        >
          {{ getLocaleText("ai_summary_panel.copied") }}
        </div>
      </Transition>
    </div>

    <div class="tw:flex tw:flex-1 tw:justify-end">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import copy from "copy-text-to-clipboard";
import { ref } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import { BaseButton, StreemTooltip } from "shared/components/base";
import { type Nullable } from "shared/types";

interface AIAssistantActions {
  copyText?: string;
}

const props = defineProps<AIAssistantActions>();

const copied = ref<boolean>(false);

let copyTimeout: Nullable<ReturnType<typeof setTimeout>> = null;

function handleCopyClick() {
  if (!props.copyText) return;

  copy(props.copyText);

  if (copied.value) return;

  if (copyTimeout) {
    clearTimeout(copyTimeout);
    copyTimeout = null;
  }

  copied.value = true;

  copyTimeout = setTimeout(() => {
    copied.value = false;
  }, 3000);
}
</script>
